import { put, call, all, takeEvery } from 'redux-saga/effects';
import { genReportActionTypes } from '../actions/generatedReportActionTypes';
import { processError } from '../../../../common/util';
import invokeApi from '../../../../common/apiManagement/invokeApi';
import { getAction } from '../../../../../stateManagement/reduxUtil';
import {
  processingStarted,
  processingCompleted,
} from '../../../../common/redux/actions/commonActions';
import moduleAPI from '../../config/apiConfig';

const generateReportTemplate = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(genReportActionTypes.GENERATE_REPORT_TEMPLATE_RESPONSE, null)),
    put(getAction(genReportActionTypes.GENERATE_REPORT_TEMPLATE_ERROR, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.GENERATE_REPORT_TEMPLATE, action.data);
    yield all([
      put(getAction(genReportActionTypes.GENERATE_REPORT_TEMPLATE_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(genReportActionTypes.GENERATE_REPORT_TEMPLATE_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
};

const listGeneratedReport = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(genReportActionTypes.LIST_GENERATED_REPORT_RESET, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.GENERATED_REPORT_LIST, action.data);
    yield all([
      put(getAction(genReportActionTypes.LIST_GENERATED_REPORT_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(genReportActionTypes.LIST_GENERATED_REPORT_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
};

const downloadGeneratedReport = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(genReportActionTypes.DOWNLOAD_GENERATED_REPORT_RESET, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.GENERATED_REPORT_DOWNLOAD, action.data);
    yield all([
      put(getAction(genReportActionTypes.DOWNLOAD_GENERATED_REPORT_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(genReportActionTypes.DOWNLOAD_GENERATED_REPORT_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
};

const deleteGeneratedReport = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(genReportActionTypes.DELETE_GENERATED_REPORT_RESET, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.GENERATED_REPORT_DELETE, action.data);
    yield all([
      put(getAction(genReportActionTypes.DELETE_GENERATED_REPORT_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(genReportActionTypes.DELETE_GENERATED_REPORT_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
};
const getReportSharedInfo = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(genReportActionTypes.RESET_REPORT_SHARE_INFO_STORE, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.GET_SHARE_REPORT_TEMPLATE, action.data);
    yield all([
      put(getAction(genReportActionTypes.GET_REPORT_SHARE_INFO_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(genReportActionTypes.GET_REPORT_SHARE_INFO_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
};

const saveReportShareInfo = function* (action) {
  yield all([
    put(processingStarted()),
    put(getAction(genReportActionTypes.SAVE_REPORT_SHARE_INFO_RESPONSE, null)),
    put(getAction(genReportActionTypes.SAVE_REPORT_SHARE_INFO_ERROR, null)),
  ]);
  try {
    const responseData = yield call(invokeApi, moduleAPI.SAVE_SHARE_REPORT_TEMPLATE, action.data);
    yield all([
      put(getAction(genReportActionTypes.SAVE_REPORT_SHARE_INFO_RESPONSE, responseData)),
      put(processingCompleted()),
    ]);
  } catch (err) {
    yield all([
      put(getAction(genReportActionTypes.SAVE_REPORT_SHARE_INFO_ERROR, processError(err))),
      put(processingCompleted()),
    ]);
  }
};

function* generatedReportWatcher() {
  yield takeEvery(genReportActionTypes.GENERATE_REPORT_TEMPLATE_REQUEST, generateReportTemplate);
  yield takeEvery(genReportActionTypes.LIST_GENERATED_REPORT_REQUEST, listGeneratedReport);
  yield takeEvery(genReportActionTypes.DOWNLOAD_GENERATED_REPORT_REQUEST, downloadGeneratedReport);
  yield takeEvery(genReportActionTypes.DELETE_GENERATED_REPORT_REQUEST, deleteGeneratedReport);

  yield takeEvery(genReportActionTypes.GET_REPORT_SHARE_INFO_REQUEST, getReportSharedInfo);
  yield takeEvery(genReportActionTypes.SAVE_REPORT_SHARE_INFO_REQUEST, saveReportShareInfo);
}

export default generatedReportWatcher;
